<template>
  <div class="aiHelper flex w-full flex-wrap lg:flex-no-wrap">
    <div class="side-bar px-5 py-4 hidden lg:flex flex-col w-full justify-between" v-if="(!ai_uuid && !$route.query.uuid) && (queryS !== 'elab')">
      <aside class="sidenav">
        <div class="mb-4">
          <img v-if="lang === 'zh'" class="block h-auto mx-auto object-contain" src="@/assets/image/ai/logo.png" alt="">
          <img v-if="lang === 'en'" class="block h-auto mx-auto object-contain" src="@/assets/image/ai/AI_LOGO2.png" alt="">
        </div>
        <ul class="sidenav__list text-white list-none p-0 text-xl">
          <li class="sidenav__list_item mb-2" v-for="(item, index) in calculateMenu" :key="index">
            <router-link
              v-if="!item.route_name || (item.route_name !== 'intro' || item.lang)"
              :to="generateRoute(item)"
              class="m-0 flex items-center p-2"
              :class="{ 'active': (item.route_name === $route.name) && (item.aiType === $route.params.aiType) && (item.promptId === $route.params.promptId) }"
            >
              <img src="@/assets/image/ai/Subtract.png" alt="" class="mr-2 object-contain" />
              {{ item.name }}
            </router-link>
          </li>
        </ul>
      </aside>

      <div>
        <a v-if="!ai_sid && !ai_uuid" class="bg-red-main-ai text-white p-2 px-3 inline-block mb-2 text-sm cursor-pointer" @click.prevent="logout()">LOGOUT</a>
      </div>
    </div>
    <div class="contain-main" :class="{ 'show_menu': (!ai_uuid && !$route.query.uuid) && (queryS !== 'elab') }">
      <headerSection :menuData="calculateMenu" />
      <router-view class="view_contain"></router-view>
      <footerSection class="hidden lg:block" />
    </div>
  </div>
</template>

<script>
  import api from '@/api'
  import headerSection from '@/components/AiHelper/headerSection'
  import footerSection from '@/components/AiHelper/footerSection'
  import { mapGetters } from 'vuex'
  export default {
    name: 'Layout',
    metaInfo: {
      title: 'AI口說小助教'
    },
    components: {
      headerSection,
      footerSection
    },

    data () {
      return {
        intervalId: null,
        menuDataEn: [
          {
            name: '使用指南',
            route_name: 'intro',
            lang: 'en'
          }
        ],
        menuDataJp: [
          {
            name: '使用指南',
            route_name: 'intro',
            lang: 'jp'
          },
          {
            name: '口說練習小幫手',
            route_name: 'ChatAIJp',
            promptId: '24a38d7e-f3de-4075-9285-a9c2ab158511'
          }
        ],
        menuDataSpeech: [
          {
            name: '使用指南',
            route_name: 'introSpeech'
          },
          {
            name: '商用英文書信小幫手',
            route_name: 'SpeechAI',
            aiType: 'letter'
          },
          {
            name: '商用日文書信小幫手',
            route_name: 'SpeechAIJp',
            aiType: 'letter'
          },
          {
            name: '英文演講稿小幫手',
            route_name: 'SpeechAI',
            aiType: 'speech'
          },
          {
            name: '日文演講稿小幫手',
            route_name: 'SpeechAIJp',
            aiType: 'speech'
          }
        ]
      }
    },

    computed: {
      ...mapGetters([
        'lang',
        'remainPoints',
        'ai_sid',
        'ai_uuid',
        'authorized'
      ]),

      calculateMenu () {
        if ((this.$route.name === 'intro' && this.$route.params.lang === 'en') || this.$route.name === 'ChatAI') {
          return this.menuDataEn
        } else if ((this.$route.name === 'intro' && this.$route.params.lang === 'jp') || this.$route.name === 'ChatAIJp') {
          return this.menuDataJp
        } else if (this.$route.name === 'introSpeech' || this.$route.name === 'SpeechAI' || this.$route.name === 'SpeechAIJp' || this.$route.name === 'viewGenerate') {
          return this.menuDataSpeech
        } else {
          return []
        }
      },

      queryS () {
        let s = this.$route.query.s || localStorage.getItem('s') || ''
        return s
      }
    },

    watch: {
    },
    created () {
    },
    beforeDestroy () {
      if (this.intervalId) {
        clearInterval(this.intervalId)
      }
    },
    mounted () {
      this.startCheckingAuth()
    },
    methods: {
      generateRoute (item) {
        const params = {}

        if (item.promptId) params.promptId = item.promptId
        if (item.aiType) params.aiType = item.aiType
        if (item.lang) params.lang = item.lang

        return {
          name: item.route_name,
          params
        }
      },
      startCheckingAuth() {
        this.intervalId = setInterval(() => {
          if (this.authorized) {
            clearInterval(this.intervalId)
            if (!this.ai_uuid) {
              this.getMenu()
            }
          }
        }, 1000)
      },
      getMenu () {
        let path = `/campus/categories`

        if (this.queryS === 'aieta') {
          path = '/chat/campus/categories'
        } else if (this.queryS === 'biztalk') {
          path = '/chat/biztalk/categories'
        } else if (this.queryS === 'elab') {
          path = '/chat/elab/categories'
        }

        api.get(path)
        .then((res) => {
          for (const [key, value] of Object.entries(res.data)) {
            this.menuDataEn.push(
              {
                name: `${key}`,
                route_name: 'ChatAI',
                promptId: `${value}`
              }
            )
          }
        })
        .catch((err) => {
          console.log(err)
        })
      },
      logout () {
        this.$store.dispatch('logout')
        this.$router.replace({ path: '/login' })
      }
    }
  }
</script>
<style lang="scss" scoped>
  .aiHelper {
    background: #eaedf2;
    text-align: left;
    .view_contain {
      min-height: calc(100vh - 60px);
      margin-top: 68px;
      @media (min-width: 1023px) {
        margin-top: 0;
      }
    }
    .side-bar {
      background: #0E103E;
      max-width: 100%;
      @media (min-width: 1023px) {
        max-width: 260px;
      }
      ul {
        list-style: none;
        list-style-position: inside;
        li {
          p {
            font-weight: 700;
            font-size: 1.125rem;
          }
          a {
            color: white;
            // font-weight: 700;
            font-size: 1.125rem;
            border-radius: 8px;
            &:hover {
              background: rgb(255, 255, 255, 0.2);
              text-decoration: none;
            }

          }
          .active {
            background: linear-gradient(180deg, #F94F39 0%, #FF763C 100%);
          }
        }
      }
    }
    .contain-main {
      background: #eaedf2;
      min-height: 100vh;
      width: 100%;

    }
    .show_menu {
      @media (min-width: 1023px) {
        width: calc(100vw - 260px);
      }
    }
    p {
      margin: 0;
      white-space: normal;
    }
  }
</style>